import { Rectangle, Sprite, Texture } from 'pixi.js';
import { EVENT, IMAGES, MainSignals } from '../../../../settings/constants';
import { SCENE_4 } from '../../../../settings/positions';
import SceneBase from '../base/SceneBase';
import { TweenMax, Power1 } from 'gsap';
import { playSfx } from '../../../../helpers/SoundManager';

const HIT_AREA = [-100, -300, 250, 650];
export default class Scene4 extends SceneBase {
  head: Sprite;

  txUp = Texture.from('4-head-open.png');
  txDown = Texture.from('4-head-closed.png');

  headDown = false;

  constructor(signals: MainSignals) {
    super(signals, SCENE_4, 4, 4);

    // parts
    const bg = Sprite.from(IMAGES.BG_4);
    bg.anchor.set(0.5);
    this.addChild(bg);

    // head
    this.head = Sprite.from('4-head-open.png');
    this.head.anchor.set(0.65, 0.9);
    this.head.x = 17;
    this.head.y = -177;
    this.addChild(this.head);

    // interaction
    this.hitArea = new Rectangle(HIT_AREA[0], HIT_AREA[1], HIT_AREA[2], HIT_AREA[3]);
    this.interactive = true;
    this.on('pointerover', this.playAnimation.bind(this));
    this.on('pointerdown', this.playAnimation.bind(this));

    // for hit area debug
    // this.buttonMode = true;
    // const hit = new Graphics();
    // hit.beginFill(0xff0000, 0.5);
    // hit.drawRect(HIT_AREA[0], HIT_AREA[1], HIT_AREA[2], HIT_AREA[3]);
    // hit.endFill();
    // this.addChild(hit);

    // listeners
    signals.stateCall.add(this.stateCall, this);
  }

  stateCall(event: string): void {
    if (event === EVENT.STATE.SPEECH_DONE) {
      setTimeout(() => {
        this.playAnimation();
      }, 1500);
    }
  }

  playAnimation(): void {
    if (this.isActive && !this.headDown) {
      this.moveDown(true);

      setTimeout(() => {
        this.moveDown(false);
      }, 4000);
    }
  }

  // --------------------------------------------------------------
  // Move
  // --------------------------------------------------------------

  moveDown(value: boolean): void {
    if (this.headDown !== value) {
      this.headDown = value;

      TweenMax.killTweensOf(this.head);
      if (this.headDown) {
        if (this.head.rotation === 0) {
          playSfx(`4-anim-${Math.floor(Math.random() * 3)}`);
        }
        TweenMax.to(this.head, 1.2, {
          rotation: -0.5,
          ease: Power1.easeInOut,
          onComplete: this.moveDownComplete.bind(this),
        });
      } else {
        this.head.texture = this.txUp;
        TweenMax.to(this.head, 1.1, {
          rotation: 0,
          ease: Power1.easeInOut,
        });
      }
    }
  }

  moveDownComplete(): void {
    this.head.texture = this.txDown;
  }
}
